import Http from '../http';

class CityService {
  // Fetch all cities
  static async getAllCities() {
    return Http.get('/cities');
  }

  // Fetch a city by ID
  static async getCityById(id) {
    return Http.get(`/cities/${id}`);
  }

  // Create a new city
  static async addCity(data) {
    console.log("Adding City:", data);
    return Http.post('/cities', data);
  }

  // Update a city
  static async updateCity(id, data) {
    console.log("Updating City:", data);
    return Http.put(`/cities/${id}`, data);
  }

  // Delete a city
  static async deleteCity(id) {
    return Http.delete(`/cities/${id}`);
  }
}

export default CityService;
